const getParsedId = (id) => {
  switch (id) {
    case 'ip':
      return 'name';
    case 'update_date':
      return 'last_modified';
    case 'workspace__name':
      return 'workspace_name';
    case 'open_service_count':
      return 'open_services';
    case 'vulnerability_count':
      return 'vulns';
    case 'create_date':
      return 'creation_time';
    case 'creator__username':
      return 'owner';
    case 'services__name':
      return 'services';
    default:
      return id;
  }
};

export default getParsedId;
